class HeaderSearch {
    constructor(container) {
        this.container = container || document;

        this.searchLink = this.container.querySelector('.header__search-link');
        this.searchModal = this.container.querySelector('.header__search-modal');
        this.searchOverlay = this.container.querySelector('.header__search-modal-overlay');
        this.searchForm = this.container.querySelector('.header__search-form');
        this.searchInput = this.container.querySelector('#search-input');
        this.searchSubmitBtn = this.container.querySelector('#search-submit-btn');
        this.searchClearBtn = this.container.querySelector('.header__search-clear');
        this.body = document.body;

        if (!this.searchModal || !this.searchLink || !this.searchInput || !this.searchSubmitBtn) {
            return;
        }

        this.init();
    }

    init() {
        this.updateSubmitAndClear();
        this.bindEvents();
    }

    updateSubmitAndClear() {
        const hasValue = this.searchInput && this.searchInput.value.trim().length > 0;

        if (this.searchSubmitBtn) {
            this.searchSubmitBtn.disabled = !hasValue;
        }

        if (this.searchClearBtn) {
            if (hasValue) {
                this.searchClearBtn.classList.add('search-form__clear--visible', 'header__search-clear--visible');
            } else {
                this.searchClearBtn.classList.remove('search-form__clear--visible', 'header__search-clear--visible');
            }
        }
    }

    openModal() {
        this.searchModal.classList.add('is-active');

        setTimeout(() => {
            if (this.searchInput) {
                this.searchInput.focus();
                this.updateSubmitAndClear();
            }
        }, 100);
    }

    closeModal() {
        this.searchModal.classList.remove('is-active');
        this.body.style.overflow = '';

        if (this.searchInput) {
            this.searchInput.value = '';
            this.updateSubmitAndClear();
        }
    }

    bindEvents() {
        if (this.searchLink) {
            this.searchLink.addEventListener('click', (e) => {
                e.preventDefault();
                this.openModal();
            });
        }

        if (this.searchOverlay) {
            this.searchOverlay.addEventListener('click', () => this.closeModal());
        }

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.searchModal && this.searchModal.classList.contains('is-active')) {
                this.closeModal();
            }
        });

        if (this.searchInput) {
            this.searchInput.addEventListener('input', () => this.updateSubmitAndClear());
            this.searchInput.addEventListener('paste', () => {
                setTimeout(() => this.updateSubmitAndClear(), 10);
            });
        }

        if (this.searchClearBtn && this.searchInput) {
            this.searchClearBtn.addEventListener('click', () => {
                this.searchInput.value = '';
                this.searchInput.focus();
                this.updateSubmitAndClear();
            });
        }

        if (this.searchForm) {
            this.searchForm.addEventListener('submit', (e) => {
                const inputValue = this.searchInput ? this.searchInput.value.trim() : '';

                if (!inputValue || (this.searchSubmitBtn && this.searchSubmitBtn.disabled)) {
                    e.preventDefault();
                    return false;
                }

                setTimeout(() => {
                    this.closeModal();
                }, 100);
            });
        }
    }

}

class HeaderMobileMenu {
    constructor(container) {
        this.container = container || document;
        this.burgerButton = this.container.querySelector('.header__burger-button');
        this.menu = this.container.querySelector('.header__mobile-menu');
        this.closeButton = this.container.querySelector('.header__mobile-menu-close');
        this.overlay = this.container.querySelector('.header__mobile-menu-overlay');
        this.footerBtn = this.container.querySelector('.header__mobile-menu-button');
        this.body = document.body;

        if (!this.burgerButton || !this.menu) {
            return;
        }

        this.init();
    }

    init() {
        this.burgerButton.addEventListener('click', () => this.open());

        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => this.close());
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', () => this.close());
        }

        if (this.footerBtn) {
            this.footerBtn.addEventListener('click', () => this.close(false));
        }

        window.addEventListener('resize', () => {
            if (!this.isMobile()) {
                this.close(false);
            }
        });
    }

    isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
    }

    open() {
        if (!this.isMobile()) {
            return;
        }

        this.menu.classList.add('is-open');
        this.body.style.overflow = 'hidden';
        this.burgerButton.setAttribute('aria-expanded', 'true');
    }

    close(restoreFocus = true) {
        this.menu.classList.remove('is-open');
        this.body.style.overflow = '';
        this.burgerButton.setAttribute('aria-expanded', 'false');

        if (restoreFocus) {
            this.burgerButton.focus();
        }
    }
}

class HeaderLanguageModal {
    constructor(container) {
        this.container = container || document;
        this.trigger = this.container.querySelector('.header__language-current');
        this.modal = this.container.querySelector('.header__language-modal');
        this.closeButton = this.container.querySelector('.header__language-modal-close');
        this.overlay = this.container.querySelector('.header__language-modal-overlay');
        this.body = document.body;

        if (!this.trigger || !this.modal) {
            return;
        }

        this.init();
    }

    init() {
        this.trigger.addEventListener('click', () => this.open());

        this.trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.open();
            }
        });

        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => this.close());
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', () => this.close());
        }

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.modal.classList.contains('is-active')) {
                this.close();
            }
        });

        window.addEventListener('resize', () => {
            if (!this.isMobile() && this.modal.classList.contains('is-active')) {
                this.close(false);
            }
        });
    }

    isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
    }

    open() {
        if (!this.isMobile()) {
            return;
        }

        this.modal.classList.add('is-active');
        this.body.style.overflow = 'hidden';
    }

    close(restoreFocus = true) {
        this.modal.classList.remove('is-active');
        this.body.style.overflow = '';

        if (restoreFocus && this.trigger) {
            this.trigger.focus();
        }
    }
}

class HeaderStickyState {
    constructor(container) {
        this.container = container || document;
        this.header = this.container.querySelector('.header');
        this.ticking = false;

        if (!this.header) {
            return;
        }

        this.init();
    }

    init() {
        this.update();
        window.addEventListener('scroll', () => this.onScroll(), { passive: true });
    }

    onScroll() {
        if (this.ticking) {
            return;
        }

        this.ticking = true;
        window.requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
        });
    }

    update() {
        const isSticky = window.scrollY > 0;
        this.header.classList.toggle('is-sticky', isSticky);
    }
}

class HeaderFeedbackButton {
    constructor(container) {
        this.container = container || document;
        this.buttons = this.container.querySelectorAll('.header__feedback-button, .header__mobile-menu-button');
        this.header = this.container.querySelector('.header');
        this.contactHashes = ['#block-contact', '#contact'];
        this.scrollGap = 16;
        this.stickyHeaderHeight = this.measureStickyHeight();

        if (!this.buttons.length) {
            return;
        }

        this.init();
    }

    init() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', (event) => this.handleClick(event, button));
        });

        window.addEventListener('resize', () => {
            this.stickyHeaderHeight = this.measureStickyHeight();
        });

        this.handleHashOnLoad();
    }

    getContactElement() {
        return document.getElementById('block-contact')
            || document.getElementById('contact')
            || document.querySelector('section.contact, .block-contact');
    }

    hasContactHash(href) {
        return this.contactHashes.some((hash) => href.includes(hash));
    }

    measureStickyHeight() {
        if (!this.header) {
            return 0;
        }

        const wasSticky = this.header.classList.contains('is-sticky');

        if (!wasSticky) {
            this.header.classList.add('is-sticky');
        }

        const height = this.header.getBoundingClientRect().height;

        if (!wasSticky) {
            this.header.classList.remove('is-sticky');
        }

        return height;
    }

    getHeaderOffset() {
        return this.stickyHeaderHeight;
    }

    scrollToContact() {
        const contactElement = this.getContactElement();

        if (!contactElement) {
            return;
        }

        const top = contactElement.getBoundingClientRect().top
            + window.scrollY
            - this.getHeaderOffset()
            - this.scrollGap;

        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    handleHashOnLoad() {
        if (!this.contactHashes.includes(window.location.hash)) {
            return;
        }

        setTimeout(() => {
            if (this.getContactElement()) {
                this.scrollToContact();
            } else {
                const siteUrl = window.backendData && window.backendData.siteUrl
                    ? window.backendData.siteUrl.replace(/\/$/, '')
                    : window.location.origin;
                window.location.href = siteUrl + '/#block-contact';
            }
        }, 100);
    }

    handleClick(event, button) {
        const href = button.getAttribute('href') || '';

        if (!href) {
            return;
        }

        const contactElement = this.getContactElement();
        if (contactElement) {
            event.preventDefault();
            this.scrollToContact();
            return;
        }

        event.preventDefault();

        let homeUrl = '/';

        try {
            const parsedUrl = new URL(href, window.location.origin);
            homeUrl = `${parsedUrl.origin}${parsedUrl.pathname}`;
        } catch (error) {
            homeUrl = '/';
        }

        window.location.href = `${homeUrl}#block-contact`;
    }
}

class AnchorScrollHandler {
    constructor() {
        this.header = document.querySelector('.header');
        this.scrollGap = 16;
        this.stickyHeaderHeight = this.measureStickyHeight();
        this.contactHashes = ['#contact', '#block-contact'];
        this.init();
    }

    measureStickyHeight() {
        if (!this.header) {
            return 0;
        }

        const wasSticky = this.header.classList.contains('is-sticky');

        if (!wasSticky) {
            this.header.classList.add('is-sticky');
        }

        const height = this.header.getBoundingClientRect().height;

        if (!wasSticky) {
            this.header.classList.remove('is-sticky');
        }

        return height;
    }

    scrollToElement(element) {
        const top = element.getBoundingClientRect().top
            + window.scrollY
            - this.stickyHeaderHeight
            - this.scrollGap;

        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    handleHashOnLoad() {
        const hash = window.location.hash;
        if (!hash || hash === '#') return;

        // Contact hashes are handled by HeaderFeedbackButton (with redirect logic)
        if (this.contactHashes.includes(hash)) return;

        setTimeout(() => {
            const target = document.querySelector(hash);
            if (target) {
                this.scrollToElement(target);
            }
        }, 100);
    }

    init() {
        window.addEventListener('resize', () => {
            this.stickyHeaderHeight = this.measureStickyHeight();
        });

        this.handleHashOnLoad();

        document.addEventListener('click', (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;

            // Contact buttons are handled by HeaderFeedbackButton
            if (anchor.matches('.header__feedback-button, .header__mobile-menu-button')) return;

            const href = anchor.getAttribute('href');
            if (!href || href === '#') return;

            const target = document.querySelector(href);
            if (!target) return;

            e.preventDefault();
            this.scrollToElement(target);

            if (history.pushState) {
                history.pushState(null, '', href);
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    new HeaderSearch(document);
    new HeaderMobileMenu(document);
    new HeaderLanguageModal(document);
    new HeaderStickyState(document);
    new HeaderFeedbackButton(document);
    new AnchorScrollHandler();
});
